export const styles = {
    paper: {
        width: '100%',
        overflow: 'auto'
    },
    disabledRole: {
        cursor: 'not-allowed'
    }
};
